import AnchorCarousel from "@components/Modules/AnchorCarousel/AnchorCarousel";
import { Ads } from "@sphtech/dmg-design-system";
import { ReactNode } from "react";

import styles from "../category.module.css";
import { CategoryLayoutElementProps } from "../types/types";

export default function CategoryAnchorCarousel({
  data,
}: CategoryLayoutElementProps): ReactNode {
  if (!data.anchorCarousel) {
    return null;
  }

  return (
    <div className={styles.categoryCarouselContainer}>
      <AnchorCarousel data={data.anchorCarousel} />

      <div className={styles.mobileAdvertisement}>
        <Ads.AdsSideBarMobile />
      </div>
    </div>
  );
}
